/* script */


































































import Vue, { PropType } from 'vue'
import { Business } from '../types'

const __vue_script__ = Vue.extend({
  props: {
    errorDeals: {
      type: Array as PropType<any[]>,
      default: (): any[] => [],
    },
    nextBusiness: {
      type: Object as PropType<Business>,
      required: false,
      default: null,
    },
  },
  computed: {
    errorDealsExists(): boolean {
      return this.errorDeals.length > 0
    },
    newSellersBusinessPath(): string {
      return this.$rails.newSellersBusinessPath()
    },
    nextBusinessPath(): string {
      return `${this.$rails.sellersBusinessPath({
        id: this.nextBusiness.id,
        new_filter: 'true',
      })}#business-toas`
    },
    newBusinessPath(): string {
      return this.$rails.newSellersBusinessPath()
    },
    hasNextBusiness(): boolean {
      return this.nextBusiness !== null
    },
    sellersDashboardPath(): string {
      return this.$rails.sellersBusinessesPath({ recommended: '1' })
    },
  },
})

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("b-alert", { attrs: { show: "", variant: "info" } }, [
        _vm._v("ご紹介ありがとうございました"),
      ]),
      _vm._v(" "),
      _vm.errorDealsExists
        ? _c(
            "b-alert",
            { attrs: { show: "", variant: "warning" } },
            [
              _vm._v(
                "\n    紹介不要な案件が " +
                  _vm._s(_vm.errorDeals.length) +
                  "件有りましたので自動でスキップ致しました。\n    "
              ),
              _c(
                "b-button",
                {
                  directives: [
                    {
                      name: "b-toggle",
                      rawName: "v-b-toggle.error-detail",
                      modifiers: { "error-detail": true },
                    },
                  ],
                  staticClass: "text-primary",
                  attrs: { size: "sm", variant: "link" },
                },
                [_vm._v("詳細")]
              ),
              _vm._v(" "),
              _c("b-collapse", { attrs: { id: "error-detail" } }, [
                _c(
                  "ul",
                  _vm._l(_vm.errorDeals, function (deal) {
                    return _c("li", { key: "error-toa-" + deal.toa_id }, [
                      _vm._v(
                        "\n          " + _vm._s(deal.toa_title) + "\n          "
                      ),
                      _c("br"),
                      _vm._v(
                        "\n          " + _vm._s(deal.errors) + "\n        "
                      ),
                    ])
                  }),
                  0
                ),
              ]),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _vm.hasNextBusiness
        ? [
            _c("p", [_vm._v("その他のおすすめ")]),
            _vm._v(" "),
            _c("b-card", [
              _c("div", { staticClass: "text-muted" }, [_vm._v("譲渡案件")]),
              _vm._v(" "),
              _c("h4", { staticClass: "h5" }, [
                _c(
                  "a",
                  {
                    staticClass: "moderate-link js-ga-event",
                    attrs: {
                      "data-event-category": "next-business-toas",
                      "data-event-action": "click",
                      "data-event-label": "title",
                      href: _vm.nextBusinessPath,
                    },
                  },
                  [_vm._v(_vm._s(_vm.nextBusiness.title))]
                ),
              ]),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "js-ga-event",
                  attrs: {
                    "data-event-category": "next-business-toas",
                    "data-event-action": "click",
                    "data-event-label": "description",
                    href: _vm.nextBusinessPath,
                  },
                },
                [
                  _c("i", { staticClass: "fad fa-circle text-danger" }),
                  _vm._v(
                    "\n        こちらの案件にもおすすめ買収ニーズがございます。ぜひご確認ください。\n      "
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "mt-4 text-center" }, [
              _c(
                "a",
                {
                  staticClass: "btn btn-outline-primary btn-lg",
                  attrs: { href: _vm.sellersDashboardPath },
                },
                [_vm._v("その他の案件を確認する")]
              ),
            ]),
          ]
        : [
            _vm._m(1),
            _vm._v(" "),
            _c("div", { staticClass: "text-center" }, [
              _c(
                "a",
                {
                  staticClass: "mt-2 btn btn-primary btn-lg",
                  attrs: { href: _vm.newBusinessPath },
                },
                [_vm._v("案件を登録する")]
              ),
            ]),
          ],
    ],
    2
  )
}
var __vue_staticRenderFns__ = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "text-danger font-weight-light px-2" }, [
      _c("i", { staticClass: "far fa-hand-point-right" }),
      _vm._v(
        "\n    案件紹介を通じてM&Aが成立した場合は、お手数ですが弊社へご連絡をお願いいたします\n  "
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "text-center" }, [
      _vm._v(
        "\n      MAfolovaには毎日新たな譲受企業が登録をしています。\n      "
      ),
      _c("br"),
      _vm._v(
        "さらにお手持ちの案件を登録して、アプローチしてみませんか？\n    "
      ),
    ])
  },
]
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "app/javascript/src/components/BulkDealSubmittedMessage.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__